import React, {useEffect} from 'react';
import AppRoutes from './Routes';

// redux

import { useDispatch } from 'react-redux';
import { fetchFeaturedProducts, fetchPickles, fetchPowders, fetchProducts, fetchRecommendedProducts, fetchSnacks, fetchSweets } from './redux/actions/productActions';
import { loadCartFromLocalStorage } from './redux/cartSlice';

// components

import Navbar from './components/Navbar';

const App = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProducts());
    dispatch(fetchFeaturedProducts());
    dispatch(fetchPickles());
    dispatch(fetchPowders());
    dispatch(fetchSweets());
    dispatch(fetchRecommendedProducts());
    dispatch(fetchSnacks());
    dispatch(loadCartFromLocalStorage());
  }, [dispatch]);

  return (
    <div>
      <Navbar />
      <div className='mt-[110px] h-auto w-[90vw] mx-[5vw]'>
        <AppRoutes />
      </div>
    </div>
  );
};

export default App;